import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { eps } from './url.service'
import { Observable } from 'rxjs'

export interface PayrollComponentRow {
  componentName: string
  values: (number | string)[] // Array to hold values for each month column
}

export interface PayrollHistoryMonthDetail {
  header: string[] // e.g., ['Salary Heads', 'Apr 2025', 'Total']
  earningsRows: PayrollComponentRow[]
  deductionsRows: PayrollComponentRow[]
  netEarnings: (number | string)[]
  totalGrossEarnings: (number | string)[]
}

export interface PayrollHistoryResponse {
  past: PayrollHistoryMonthDetail
  future: PayrollHistoryMonthDetail
  currency: string
}

@Injectable({ providedIn: 'root' })
export class ContractorPayrollSummaryService {
  http = inject(HttpClient)
  api = eps.hrm.runContractorPayrollApi

  getFinancialYears(employeeId: string): Observable<string[]> {
    return this.http.get<string[]>(`${this.api}/financialYears/${employeeId}`)
  }

  loadSummary(
    employeeId: string,
    financialYear: string,
    belongsTo: string
  ): Observable<PayrollHistoryResponse> {
    return this.http.get<PayrollHistoryResponse>(`${this.api}/summary/${employeeId}`, {
      params: { financialYear, belongsTo }
    })
  }
}
